import Helpers from "../helpers";

export default class Newsroom {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!element) return;

        try {
            this.dropdowns = this.element.querySelectorAll(
                ".newsroom__dropdown-toggle"
            );
        } catch (error) {
            return;
        }
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        Helpers.forEach(this.dropdowns, (index, item) => {
            item.addEventListener("click", e => {
                e.preventDefault();
            });
        });
    }

    animSlideOut(element, duration = 0.8) {}

    animSlideIn(element, duration = 0.8) {}
}
